export class ScPortalRequestDuties{
    dutyType:string;
    scDutiesId:number;
    dutyDescription:string;
    monthlyAmount:number;
    portalUserId:number;
    totalAmount:number;
    rowStatus:string;
    id:number;
    
}